<app-background backgroundImage="images/shared/backgrounds/background-3.avif" height="100%" width="100%" opacity=".8">

    <div class="w-full min-h-screen flex flex-col justify-center items-center px-6 sm:px-12">

        <h1 class="text-[60px] sm:text-[80px] md:text-[100px] lg:text-[120px] font-bold mb-6 whitespace-nowrap text-center"> THANK YOU</h1>
        <div class="">
            <p class="text-base sm:text-lg md:text-xl mb-4">
                Thank you for booking - we are looking forward to your call.
            </p>
            <p class="text-base sm:text-lg md:text-xl mb-10">
                In the meantime, you can check out our
                <span class="gradient-text font-semibold cursor-pointer" (click)="navigateTo('blog')">blog</span>
                and
                <span class="gradient-text font-semibold cursor-pointer"
                    (click)="navigateTo('case-studies')">case studies</span>
                to get a better <br class="hidden sm:block">
                understanding of what <b>SEM Nexus</b> can do for you.
            </p>
        </div>

        <div class="w-full flex justify-center">
            <app-button buttonText="RETURN HOME" (click)="navigateTo('/')"></app-button>
        </div>

    </div>

</app-background>